"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listComponents = void 0;
const components_1 = require("@/store/ducks/components");
const components_2 = require("@/services/components");
const utilities_1 = require("@/utilities");
function listComponents() {
    return (dispatch) => {
        dispatch((0, components_1.getComponentsList)());
        (0, components_2.getComponents)()
            .then((components) => {
            const componentsRow = components
                .map((component) => {
                return {
                    id: component.id,
                    name: component.name,
                    unit: component.unit,
                    updatedAt: (0, utilities_1.defineUpdateDate)({
                        updatedAt: component.updatedAt,
                        createdAt: component.createdAt,
                    }),
                    deletable: true,
                    analysis: component.analysis,
                    formula: component.formula,
                    order: component.order,
                    possibleUnits: parsePossibleUnits(component),
                };
            })
                .sort((0, utilities_1.sortByProperty)("order"));
            dispatch((0, components_1.getComponentsListSuccess)(componentsRow));
        })
            .catch(() => {
            dispatch((0, components_1.getComponentsListError)());
        });
    };
}
exports.listComponents = listComponents;
const parsePossibleUnits = (component) => {
    if (component.possibleUnits) {
        const units = JSON.parse(component.possibleUnits);
        const possibleUnits = units.includes(component.unit)
            ? units
            : [...units, component.unit];
        return possibleUnits;
    }
    return [];
};
exports.default = {
    listComponents,
};
